import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { HeadingParagraph } from './Heading';
import { ParagraphRegularSub } from './Paragraph';

const FullContainer = styled.div`
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
  margin: 15px 0;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const IconContainer = styled.div`
  margin-right: 25px;
`;

const DescriptionContainer = ({ title, description, Icon }) => {
  const { t } = useTranslation();

  return (
    <>
      <FullContainer>
        {!!Icon && (
          <IconContainer>
            <Icon />
          </IconContainer>
        )}
        <Container>
          <HeadingParagraph isNormal>{t(title)}</HeadingParagraph>
          {!!description && (
            <ParagraphRegularSub>{t(description)}</ParagraphRegularSub>
          )}
        </Container>
      </FullContainer>
    </>
  );
};

DescriptionContainer.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  Icon: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.string,
    PropTypes.shape({ render: PropTypes.func.isRequired }),
  ]),
};

export default DescriptionContainer;
